export default {
  SET_LANGUAGE: 'session/SET_LANGUAGE',
  LOGOUT: 'session/LOGOUT',
  SET_USER_INFO: 'session/SET_USER_INFO',
  SET_SHIFT: 'session/SET_SHIFT',
};
